module.exports = __webpack_public_path__ + "media/images/icons/underline-bff738e070181a62f6574ae3adbdf6ce.svg";